import { render, staticRenderFns } from "./form2.vue?vue&type=template&id=0f19189a&"
import script from "./form2.vue?vue&type=script&lang=js&"
export * from "./form2.vue?vue&type=script&lang=js&"
import style0 from "./form2.vue?vue&type=style&index=0&id=0f19189a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports